import { jwtDecode } from 'jwt-decode';
import React from 'react';
import styled from 'styled-components';

import { GoogleLogin } from '@react-oauth/google';

interface IGLoginProps {
    onSuccess: ({ email, name, profilePictureUrl }: { email: string, name: string, profilePictureUrl?: string }) => void;
}

const StyledContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

const GLogin: React.FC<IGLoginProps> = ({ onSuccess }) => {
    const responseMessage = async (response: unknown) => {
        const { credential } = response as { credential: string };

        // Decode the JWT token to get user information
        try {
            const decodedToken: { email: string, name: string, picture: string } = jwtDecode(credential);
            console.log('Decoded Token:', decodedToken);

            const { email, name, picture } = decodedToken;
            console.log('User Email:', email);
            console.log('User Name:', name);
            console.log('User Picture:', picture);
            onSuccess({ email, name, profilePictureUrl: picture });

            // Handle user data (email, name, etc.)
        } catch (error) {
            console.error('Error decoding token:', error);
        }
    };
    const errorMessage = () => {
        console.log('error');
    };
    return (
        <StyledContainer>
            <GoogleLogin onSuccess={responseMessage} onError={errorMessage} auto_select={false} />
        </StyledContainer>
    );
};
export default GLogin;